module.exports = __webpack_public_path__ + "static/media/ico.224bcbcd.svg";